<template>
  <div class="mt-2 px-0 p-12 text-center relative w-full">
    <p v-if="false" id="progress">{{ progress }}</p>

    <vue-word-cloud
      v-if="words.length"
      style="height: 1080px; width: 1920px"
      :words="words"
      :color="generateColor"
      :font-family="fontFamily"
      :animation-duration="animationDuration"
      :rotation="getRotation"
      @update:progress="setProgress"
    />

    <p
      v-if="!words.length"
      class="mt-12 text-xl sm:text-2xl font-extralight text-gray-400"
    >
      ---
    </p>
  </div>
</template>

<script>
import Spinner from '@/Shared/Spinner';
import VueWordCloud from 'vuewordcloud';
import { sample } from 'lodash';

export default {
  name: 'WordCloud',

  components: {
    Spinner,
    [VueWordCloud.name]: VueWordCloud,
  },

  props: ['words'],

  data() {
    return {
      fontFamily: 'Gilroy',
      color: this.generateColor,
      animationDuration: 0,
      rotation: this.getRotation,
      progress: 0,
    };
  },

  methods: {
    setProgress(progress) {
      if (progress == null) {
        return;
      }

      this.progress = Math.floor(progress.completedWords / progress.totalWords);
    },

    generateColor() {
      var colors = ['#53c9ff', '#4bb5e6', '#42a1cc', '#3a8db3'];

      return sample(colors);
    },

    getRotation() {
      var rotations = [0, 1 / 4];

      return sample(rotations);
    },
  },
};
</script>